'use strict';

/* jshint -W098 */
angular.module('mean.admin-panel').controller('TradeAdminBidProfilesController', ['$scope', 'Global', 'Users', 'MeanUser', 'BidMaterialsSaves', 'userService', 'toaster', '$filter', '$location',
    function ($scope, Global, Users, MeanUser, BidMaterialsSaves, userService, toaster, $filter, $location) {
        $scope.global = Global;
        $scope.package = {
            name: 'admin-panel'
        };

        $scope.user = MeanUser.user;
        $scope.profiles = [];

        $scope.init = function () {
            console.log($scope.bid, 'BidMaterialsSaves Admin Profile')
            if (userService.isAdmin($scope.user)) {
                userService.getMainAccountId($scope.user.username).then(function (id) {
                    BidMaterialsSaves.query({ 'user': id }, function (profiles) {
                        _.each(profiles, function (profile) {
                            //originally the name would be of the form <name string> - <date>
                            //the user could enter dashes in the name.  Now we need to split
                            //<name string> and <date> and store in their own parameters.
                            //first lets split the name and check the last array element.
                            //if the last element is a date and the date parameter does
                            //not exist, then create the new name and the date parameter and save.
                            var array = profile.name.split('-');
                            var date_obj = new Date(array[array.length - 1]);
                            if (angular.isDate(date_obj) && angular.isUndefined(profile.date)) {
                                profile.name = '';
                                //recreate the name and put back in the dashes
                                for (var i = 0; i < array.length - 1; i++) {
                                    profile.name += array[i];
                                    if (i < array.length - 2) {
                                        profile.name += '-';
                                    }
                                }

                                //store the date portion from the original name
                                profile.date = date_obj;

                                profile.$update(function (success) {
                                    //success.date = $filter('date')(new Date(success.date), "ddMMMyyyy");
                                    success.date = moment(success.date);
                                    $scope.profiles.push(success);
                                }, function (error) {
                                    toaster.pop('error', 'Profile Save Error', error);
                                    return;
                                });
                            } else {
                                //profile.date = $filter('date')(new Date(profile.date), "ddMMMyyyy");
                                profile.date = moment(profile.date);
                                $scope.profiles.push(profile);
                            }
                        });
                    });
                });
            } else {
                toaster.pop('error', 'Trade Costs', 'You do not have proper permissions.');
                $location.path('home');
            }
        };

        $scope.removeProfile = function (item) {
            var idx = $scope.profiles.indexOf(item);
            if (idx === -1) {
                toaster.pop('error', 'Finding Profile Error', 'Contact Admin');
                return;
            }

            item.$delete(function (success) {
                $scope.profiles.slice(idx, 1);
                toaster.pop('success', 'Bid Profile Removed');
            }, function (error) {
                toaster.pop('error', 'Bid Profile Error', error);
            });
        };

        $scope.editName = function (item) {
            item.nameEditing = true;
        };

        $scope.doneNameEditing = function (item) {
            if (!item.nameEditing) return;

            //item.date = new Date(item.date);

            var idx = $scope.profiles.indexOf(item);

            item.$update(function (success) {
                //$scope.profiles[idx].date = $filter('date')(new Date(success.date), "ddMMMyyyy");
                $scope.profiles[idx].date = moment(success.date);
                toaster.pop('success', 'Name Updated');
            }, function (error) {
                toaster.pop('error', 'Name Update Error', error);
            });

            item.nameEditing = false;
        };

        $scope.editDate = function (item) {
            item.dateEditing = true;
        };

        $scope.doneDateEditing = function (item) {
            if (!item.dateEditing) return;

            item.$update(function (success) {
                //success.date = $filter('date')(new Date(success.date), "ddMMMyyyy");
                success.date = moment(success.date);
                toaster.pop('success', 'Date Updated');
            }, function (error) {
                toaster.pop('error', 'Date Update Error', error);
            });

            item.dateEditing = false;
        };
    }
]);



// WEBPACK FOOTER //
// ./packages/custom/admin-panel/public/controllers/tradeAdminBidProfiles.js